import axiosInstance from './AxiosInstance';

export const getDailyStatsCurrentMonth = async () => {
  try {
    const response =  await axiosInstance.get(`/graph/daily-stats-current-month`);
    return response.data;
  } catch (error) {
    return { success: false, error };
  }
};
